import { MASTER_GAIN } from "./constants";

export class Mixer {
  private masterGain: GainNode | null = null;
  private limiter: DynamicsCompressorNode | null = null;

  getOutput(context: AudioContext): GainNode {
    if (!this.masterGain) {
      this.masterGain = context.createGain();
      this.masterGain.gain.value = MASTER_GAIN;
    }

    return this.masterGain;
  }

  connectToOutput(context: AudioContext): void {
    const master = this.getOutput(context);

    if (!this.limiter) {
      this.limiter = context.createDynamicsCompressor();
      this.limiter.threshold.value = -12;
      this.limiter.knee.value = 16;
      this.limiter.ratio.value = 6;
      this.limiter.attack.value = 0.003;
      this.limiter.release.value = 0.18;
      master.connect(this.limiter);
      this.limiter.connect(context.destination);
    }
  }
}
